import { useCallback } from "react";

import { Tooltip as BaseTooltip } from "@bokio/design-system-base/components/Tooltip/Tooltip";
import { trackEvent } from "@bokio/utils/t";

import type { TooltipProps as BaseTooltipProps } from "@bokio/design-system-base/components/Tooltip/Tooltip";

export interface TooltipProps extends BaseTooltipProps {
	trackinfo?: string;
}

export const Tooltip = ({ trackinfo, onVisibilityChange, ...props }: TooltipProps) => {
	const handleVisibilityChange = useCallback(
		(open: boolean) => {
			onVisibilityChange?.(open);

			if (trackinfo) {
				trackEvent("Tooltip", open ? "Open" : "Close", trackinfo);
			}
		},
		[onVisibilityChange, trackinfo],
	);

	return <BaseTooltip {...props} onVisibilityChange={handleVisibilityChange} />;
};

export type { TooltipPlacement } from "@bokio/design-system-base/components/Tooltip/tooltipUtils";

export default Tooltip;
